module.exports = __webpack_public_path__ + "img/shadow.5cd602a.webp";